export const PERMISSIONS = {
  VIEW: {
    syncMonitor: 'view-sync-monitor',
    centersList: 'view-centers-list',
    countriesList: 'view-countries-list',
    projectsList: 'view-projects-list',
    usersList: 'view-users-list',
    usageStats: 'view-usage-stats',
    resultsStats: 'view-results-stats',
    analysisStats: 'view-analysis-stats',
    identificationStats: 'view-identification-stats',
    otherUserDetails: 'view-other-user-details',
    ownUserDetails: 'view-own-user-details',
  },
  CREATE: {
    user: 'create-user',
  },
  UPDATE: {
    user: 'update-other-user',
    ownUser: 'update-own-user',
  },
  DELETE: {
    user: 'remove-other-user',
    ownUser: 'remove-own-user',
  },
  RESET: {
    password: 'reset-other-password',
    ownPassword: 'reset-own-password',
  },
};
